import React, { useState, useContext } from 'react';
import { EllipsisDropdown, Person, Table } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, DropdownItem } from 'semantic-ui-react';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import campaignActions from 'actions/campaigns';
import { Notification, STATUS_TYPES, USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

export const UsersRow = ({ user, campaignId, readUsers }) => {
    const [selectedUsers, setSelectedUsers] = useContext(BulkActionsContext);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dispatch = useDispatch();

     const { campaign, user_id } = useSelector(state => ({
        campaign: state.campaigns.campaign,
        user_id: state.auth.user_id
    }));

    const isCompany = Object.keys(campaign?.is_company_campaign || []).length > 0;
    const isOwner = campaign.user_owner_id !== user_id;

    const isSelected = (user_id) => {
        return selectedUsers.includes(user_id);
    }

    const onToggleUser = (user_id) => {
        const newSelectedUsers = isSelected(user_id) ? selectedUsers.filter(id => user_id !== id) : [...selectedUsers, user_id];
        setSelectedUsers(newSelectedUsers);
    }

    const countsToDisplay = user.campaign_converted_count || 0;

    const removeAndUnRemoveCampaign = async (user_id, isDeleted) => {
        try {
            setIsDropdownOpen(false);
            if (isDeleted) {
                await dispatch(campaignActions.createCampaignUserReport([user_id], null, campaignId));
                Notification.alert("Successfully added user!", STATUS_TYPES.SUCCESS, true);
                dispatch(campaignActions.readCampaignUserIds(campaignId));
            } else {
                await dispatch(campaignActions.deleteCampaignUser(campaignId, { user_id }));
                Notification.alert("Successfully removed user!", STATUS_TYPES.SUCCESS, true);
                dispatch(campaignActions.readCampaignUserIds(campaignId));
            }
            readUsers();
        } catch (e) {
            console.log(e);
            Notification.alert(`Failed to ${isDeleted ? "add" : "remove"}.`, STATUS_TYPES.ERROR, true);
        }
    }

    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox checked={isSelected(user.user_id)} onChange={() => { onToggleUser(user.user_id) }} />
            </Table.Cell>
            <Table.Cell>
                <Person
                    username={`${user.user.username}  ${user?.deleted ? '(removed)' : ''}` }
                    email={user.user.email}
                    isInactiveUser={user.user.active === false}

                />
            </Table.Cell>
            <Table.Cell>
                {user.conversion_rate}%
            </Table.Cell>

            <Table.Cell>
                {countsToDisplay || 0}
            </Table.Cell>
            <Table.Cell>
                {user.total_calls}
            </Table.Cell>
            <Table.Cell>
                {user.attributed_revenue}
            </Table.Cell>
            <Table.Cell>
                {!user.is_owner && (
                    <EllipsisDropdown isDropdownOpen={isDropdownOpen} toggleEllipsisDropdown={()=>{setIsDropdownOpen(isDropdownOpen=>!isDropdownOpen)}}>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.CAMPAIGNS_DELETE} userRestrict modifiers={isCompany ? 'company' : 'personal'}>
                            <DropdownItem
                                text={user?.deleted ? 'Unremove From Campaign' : 'Remove From Campaign'}
                                icon={user?.deleted ? "fa-sharp fa-solid fa-user-plus" : "fa-solid fa-user-slash"}
                                onClick={() => removeAndUnRemoveCampaign(user?.user_id, user?.deleted)}
                                disabled={isOwner}
                            />
                        </RestrictedView>
                    </EllipsisDropdown>
                )}
            </Table.Cell>
        </Table.Row>
    );
}
